export var UserSortColumn;
(function (UserSortColumn) {
    UserSortColumn["INDEX"] = "#";
    UserSortColumn["NAME"] = "Name";
    UserSortColumn["MAIL"] = "E-Mail";
    UserSortColumn["GENDER"] = "Anrede";
    UserSortColumn["STATUS"] = "Status";
    UserSortColumn["OFFICE_LOCATION"] = "Standort";
    UserSortColumn["ROLE"] = "Berechtigung";
})(UserSortColumn || (UserSortColumn = {}));
//# sourceMappingURL=user-sort-column.enum.js.map